
export const getScenePickerStyles = (_, { palette = {} }) => ({
  scenePicker: {
    '& .item-title': {
      '& span': {
        fontWeight: 600,
      },
      marginBottom: 8,
    },
    '& .scene': {
      '& .scene-decorator': {
        borderRadius: 6,
        '& .scene-box': {
          overflow: 'hidden',
          '&.selected': {
            outlineColor: palette.themePrimary || '#0078d4',
            outlineStyle: 'solid',
          },
          width: 102,
          padding: 1,
          height: 60,
          borderRadius: 6,
        },
        '& img': {
          height: '100%',
          width: '100%',
          objectFit: 'cover',
          borderRadius: 6,
        },
      },
      '& .scene-index-block': {
        marginTop: 4,
        marginBottom: 16,
        '& span': {
          verticalAlign: 'middle',
          lineHeight: '20px',
        },
      },
    },
  },
});
